import * as React from "react"

function Cross(props) {
  const { className, isOpen } = props
  return (
    <svg
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >

    <path
      d="M1 7L13 7"
      stroke="#0C1414"
      strokeWidth={1}
      strokeLinecap="square"
    />
    <path
      d="M7 13L7 1"
      stroke="#0C1414"
      strokeWidth={1}
      strokeLinecap="square"
      className={`transition-all origin-center duration-300  ${isOpen ? `rotate-90 opacity-25` : ``}`}
    />
 
  </svg>
  )
}

export default Cross
